import type { RowMarkerOptions } from './types'

export const preventRowClickOnSelectionCheckbox = (
  rowMarkers: RowMarkerOptions['kind'],
  location: number,
) => !['number', 'none'].includes(rowMarkers as string) && location === -1
